/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from "@atproto/lex";

const $nsid = "place.stream.moderation.permission";

export { $nsid };

/** Record granting moderation permissions to a user for this streamer's content. */
type Main = { $type: "place.stream.moderation.permission";

  /**
   * The DID of the user granted moderator permissions.
   */
  "moderator":l.DidString;

  /**
   * Array of permissions granted to this moderator. 'ban' covers blocks/bans (with optional expiration), 'hide' covers message gates, 'livestream.manage' allows updating livestream metadata.
   */
  "permissions":("ban" | "hide" | "livestream.manage" | "message.pin" | "vod.comment.hide")[];

  /**
   * Client-declared timestamp when this moderator was added.
   */
  "createdAt":l.DatetimeString;

  /**
   * Optional expiration time for this delegation. If set, the delegation is invalid after this time.
   */
  "expirationTime"?:l.DatetimeString };

export type { Main };

/** Record granting moderation permissions to a user for this streamer's content. */
const main = /*#__PURE__*/ l.record<"tid", Main>("tid", $nsid, /*#__PURE__*/ l.object({"moderator":/*#__PURE__*/ l.string({"format":"did"}),"permissions":/*#__PURE__*/ l.array(/*#__PURE__*/ l.enum(["ban","hide","livestream.manage","message.pin","vod.comment.hide"]), ),"createdAt":/*#__PURE__*/ l.string({"format":"datetime"}),"expirationTime":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.string({"format":"datetime"}))}));

export { main };

export const $type = $nsid;
export const $isTypeOf = /*#__PURE__*/ main.isTypeOf.bind(main);
export const $build = /*#__PURE__*/ main.build.bind(main);
export const $assert = /*#__PURE__*/ main.assert.bind(main);
export const $check = /*#__PURE__*/ main.check.bind(main);
export const $cast = /*#__PURE__*/ main.cast.bind(main);
export const $ifMatches = /*#__PURE__*/ main.ifMatches.bind(main);
export const $matches = /*#__PURE__*/ main.matches.bind(main);
export const $parse = /*#__PURE__*/ main.parse.bind(main);
export const $safeParse = /*#__PURE__*/ main.safeParse.bind(main);
export const $validate = /*#__PURE__*/ main.validate.bind(main);
export const $safeValidate = /*#__PURE__*/ main.safeValidate.bind(main);
